import { css } from 'styled-components';

export default css`
  display: inline-block;
  padding: 1rem;
  color: ${t => t.theme.white};
  border: 2px solid ${t => t.theme.blue};
  background: ${t => t.theme.blue};
  text-decoration: none;
  text-transform: uppercase;
  font-weight: bold;

  &:hover,
  &:focus {
    color: ${t => t.theme.blue};
    background: ${t => t.theme.white};
  }
`;



// WEBPACK FOOTER //
// ./src/Components/Button/StyleButtonBase.js